// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1550":"e5ed242c","1595":"d0434195","3148":"b627e416","6925":"48d89701"}[chunkId] + ".chunk.css";
};